import React, { useState, useCallback, ChangeEvent } from 'react';
import title from 'Icons/RM_Title.png';
import Logo from 'Icons/RMlogo.png';
import { showAlertSnackBar } from 'utils/Global';
import { useNavigate } from 'react-router-dom';
import UserGroupService from 'business/services/UserGroupService';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import useModel from 'business/models/useModel';
import { ResponseDTO, ResponseType, UserOtpDTO } from 'business/models/Models';
import { Input, InputWithIcon } from 'components/input';
import { FormActionButton } from 'components/Button';
import useAppInfo from 'CustomHooks/useAppInfo';

const InputOTP = () => {
  const navigate = useNavigate();
  const [otp, setOTP] = useState(null);
  const [userName, setUserName] = useState('');
  const [changePassword] = useModel(UserGroupService, 'submitChangePassword');
  const appInfo = useAppInfo();
  const appVersion = appInfo?.version;
  const appCopyRights = appInfo?.copyRight;
  const [passwordDetail, setPasswordDetail] = useState({
    password: '',
    confirmPassword: '',
  });

  const handleSetPasswordDetail = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setPasswordDetail((prv) => ({
        ...prv,
        [e.target.name]: isNaN(parseInt(e.target.value))
          ? e.target.value
          : parseInt(e.target.value),
      }));
    },
    [setPasswordDetail],
  );

  const handleBackToLoginClick = () => {
    navigate('/login');
  };

  const openFormulatrixWebsite = (e) => {
    window.open('http://www.formulatrix.com/', '_blank');
  };

  const changeOTP = (e) => {
    setOTP(e.target.value);
  };

  const changeUserName = (e) => {
    setUserName(e.target.value);
  };

  const submitChangePassword = async () => {
    const otpDetails: UserOtpDTO = new UserOtpDTO();
    otpDetails.otp = otp;
    otpDetails.password = passwordDetail.password;
    otpDetails.userName = userName;
    const response: ResponseDTO = await changePassword(otpDetails);
    if (response.responseType == ResponseType.Error) {
      showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, response.message);
    } else if (response.responseType == ResponseType.Success) {
      showAlertSnackBar(EAlertType.SUCCESS, ESnackBarPosition.TOP, response.message);
      navigate('/login');
    }
  };

  return (
    <div id="input-otp-container" className="mainContainer">
      <div id="input-otp-header-row" className="headerRow">
        <div id="input-otp-header-logo" className="headerLogo">
          <img id="input-otp-img-logo" src={Logo} />
        </div>
        <div id="input-otpinput-otp-header-title" className="headerTitle">
          <img
            id="input-otp-title-image"
            className="titleImage"
            src={title}
            alt="RM title"
          />
        </div>
      </div>
      <div id="input-otp-inner-container" className="innerContainer">
        <div id="input-otp-login" className="login flex-y-center flex-column">
          <div
            id="input-otp-login-heading"
            className="loginHeading flex-y-center flex-column"
          >
            <div>
              ROCK MAKER
              <span id="input-otp-registered-logo" className="registeredLogo">
                &#174;
              </span>{' '}
              Crystallization Software
            </div>
          </div>

          <div id="input-otp-login-form" className="loginForm flex-y-center flex-column">
            <div id="input-otp-form-change" className="fields">
              <div id="input-otp-form-change-code" className="my-2">
                Code
                <Input
                  id="input-otp-code"
                  type="number"
                  placeholder="Code"
                  value={otp}
                  onChange={changeOTP}
                  autoFocus
                />
              </div>
              <div id="input-otp-form-change-user-name" className="my-2">
                User Name
                <Input
                  id="input-otp-user-name"
                  type="text"
                  placeholder="User Name"
                  value={userName}
                  onChange={changeUserName}
                  autoFocus
                />
              </div>
              <div id="input-otp-form-change-new-password" className="my-2">
                New Password
                <InputWithIcon
                  name={'password'}
                  value={passwordDetail.password}
                  onChange={handleSetPasswordDetail}
                  inputType="password"
                  placeholder="New Password"
                />
              </div>
              <div id="input-otp-form-change-confirmation-password">
                Confirmation Password
                <InputWithIcon
                  name={'confirmPassword'}
                  value={passwordDetail.confirmPassword}
                  onChange={handleSetPasswordDetail}
                  inputType="password"
                  placeholder="Confirmation Password"
                />
              </div>
            </div>
            <div
              id="input-otp-form-change-action-button"
              className="fields flex-x-center"
            >
              <FormActionButton
                onSaveClick={submitChangePassword}
                saveText={'Proceed'}
                discardText="Cancel"
                onDiscardClick={handleBackToLoginClick}
                saveDisabled={
                  passwordDetail.password != passwordDetail.confirmPassword ||
                  passwordDetail.password == '' ||
                  otp == null
                }
              />
            </div>
          </div>
          <div
            id="input-otp-form-change-row-bottom-details"
            className="row bottomDetails flex flex-space-between"
          >
            <div
              id="input-otp-form-change-cols-bottom-details-version"
              className="col-md-4 bottomDetailsCols"
            >
              Version {appVersion}
            </div>
            <div
              id="input-otp-form-change-cols-bottom-details-selected"
              className="col-md-4 bottomDetailsCols bottomDetailsColsSelected"
              onClick={openFormulatrixWebsite}
            >
              Formulatrix Inc.
            </div>
            <div
              id="input-otp-form-change-col-bottom-details-copy-rights"
              className="col-md-4 bottomDetailsCols"
            >
              ©{appCopyRights}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InputOTP;
